import React from "react";
import { graphql, Link } from "gatsby";
import "../scss/news-article-page.scss";
import 'uikit/dist/css/uikit.css'

import Layout from "../components/layout";
import SEO from "../components/seo";
import CustomMarkdown from "../utils/customMarkdown"
import Img from "gatsby-image";
import GetImgUrl from "../utils/customFunctions";
import { removeSlashFromSlug } from '../utils/additionalFunctions';
import loadable from '@loadable/component'

const QuoteCarousel = loadable(() => import("../components/quote-carousel"))
const Branches = loadable(() => import("../components/branches-component"))
const Tiles = loadable(() => import("../components/tiles"))
const Hero = loadable(() => import("../components/basic-components/hero"))
const Paragraph = loadable(() => import("../components/paragraph"))
const VideoComponent = loadable(() => import("../components/video-component"))
const StepsComponent = loadable(() => import("../components/steps-component"))
const FAQComponent = loadable(() => import("../components/faq-component"))
const SwirlComponent = loadable(() => import("../components/swirl-component"))
const Signup = loadable(() => import("../components/signup"))

export const query = graphql`
  query newsArticlePagesQuery($id: Int) {
    strapiNewsArticle(strapiId: { eq: $id }) {
      SEOTitle
      SEODescription
      Canonical
      MetaTags{
        MetaName
        MetaContent
      }
      Components
      Title
      id
      slug
      Header {
        RightBgColor
        LeftBgColor
        Title
        Subtitle
        Visible
        CTA
        URL
        CTASecondary
        URLSecondary
        Background {
          localFile {
            publicURL
            childImageSharp {
              fluid(quality: 90, maxWidth: 1900) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  }
`;


const newsArticle = ({ data }) => {
  var headerData = data.strapiNewsArticle.Header != null ? {
    headerTitle: data.strapiNewsArticle.Header.Title
      ? data.strapiNewsArticle.Header.Title
      : "",
    headerDescription: data.strapiNewsArticle.Header.Subtitle
      ? data.strapiNewsArticle.Header.Subtitle
      : "",
    headerCTAPrimaryLabel: data.strapiNewsArticle.Header.CTA
      ? data.strapiNewsArticle.Header.CTA
      : "",
    headerCTAPrimaryUrl: data.strapiNewsArticle.Header.URL
      ? data.strapiNewsArticle.Header.URL
      : "",
    headerCTASecondaryLabel: data.strapiNewsArticle.Header.CTASecondary
      ? data.strapiNewsArticle.Header.CTASecondary
      : "",
    headerCTASecondaryUrl: data.strapiNewsArticle.Header.URLSecondary
      ? data.strapiNewsArticle.Header.URLSecondary
      : "",
    headerBgImage: data.strapiNewsArticle.Header.Background?.localFile.childImageSharp.fluid||{src:process.env.GATSBY_DEFAULT_NA_IMAGE},
    headerRightBgColor: data.strapiNewsArticle.Header.RightBgColor ? data.strapiNewsArticle.Header.RightBgColor : '',
    headerLeftBgColor: data.strapiNewsArticle.Header.LeftBgColor ? data.strapiNewsArticle.Header.LeftBgColor : '',

  } : {};


  const url ="https://mindfulmemorials.co.uk";
  const pageHasHeader = data.strapiNewsArticle.Header != null ? true : false; //check if Header is set
  var headerParagraphSet = false;

  return (
    <div>
      <Layout
        pageData={headerData}
        headerShow={data.strapiNewsArticle.Header != null ? data.strapiNewsArticle.Header.Visible : false}
        shareOnSocial={true}
      >
        <SEO title={data.strapiNewsArticle.SEOTitle?data.strapiNewsArticle.SEOTitle:data.strapiNewsArticle.Title} 
        description={data.strapiNewsArticle.SEODescription} 
        meta={data.strapiNewsArticle.MetaTags}
        canonical={data.strapiNewsArticle.Canonical ? data.strapiNewsArticle.Canonical : `${url + '/news/' + removeSlashFromSlug(data.strapiNewsArticle.slug)}`}
        />
        <div className="news-article-page padding-top padding-bottom lateral-padding">
          {/* {data.strapiNewsArticle.Components.map((item, index) => {
            return (
              <div key={index}>
                 <CustomMarkdown children={item.Text} /> 
                
                {item.ImageCarousel ? (
                  <div className="event-page-image uk-height-medium uk-cover-container uk-margin-none">
                    <Img
                      fluid={
                        GetImgUrl(item.ImageCarousel.Images.localFile___NODE)
                          .fluid
                      }
                      alt="image"
                    ></Img>
                  </div>
                ) : null} 

                 {item.Links ? (
                  <Link to={item.Links.URL} className="event-page-link">
                    {item.Links.Link}
                  </Link>
                ) : null} 

                 {item.Testimonial 
                  ? (<div className="">
                      <QuoteCarousel quoteList={item.Testimonial}></QuoteCarousel>
                    </div>
                    ) 
                  : (
                    ""
                  )} 
              </div>
            );
          })} */}

          {data.strapiNewsArticle.Components.map((item, index) => {
            switch (item.strapi_component) {
              case "basic-components.text-section":
                return (
                  <>
                    <div key={index}>
                      <CustomMarkdown children={item.Text} />
                    </div>
                    {item.Links ? (
                        <Link to={item.Links.URL} className="event-page-link">
                          {item.Links.Link}
                        </Link>
                      ) : null}
                  </>           
                )
              case "basic-components.paragraph":
                  var forceH1Title = false;
                  var overlaySwirl = false;
                  if((pageHasHeader == false && headerParagraphSet == false) || item.IsHeader == true){
                    headerParagraphSet = true;
                    forceH1Title = true;
                  }
  
                  if(index == 0 && item.TopSwirl == true){ //if paragraph is the first item in pageComponents and has topSwirl then overlay the header image
                    overlaySwirl = true;
                  }
                  return (               
                      <Paragraph
                          key={index}
                          title={item.Title}
                          text={item.Text}
                          image={item.Image}
                          imagePosition={item.ImagePosition}
                          bgColor={item.BackgroundColor || ""}
                          topPadding={(item.TopPadding === true) ? true : false}
                          bottomPadding={(item.BottomPadding === true) ? true : false}
                          forceH1Title={forceH1Title}
                          alignment={item.ContentAlignment}
                          initialPadding={item.InitialPadding}
                          topSwirl={item.TopSwirl}
                          bottomSwirl={item.BottomSwirl}
                          bottomMargin={item.BottomMargin}
                          overlaySwirl={overlaySwirl}
                      ></Paragraph>
                  )
              case "basic-components.hero-section":
                return(
                  <Hero
                    title={item.Hero.Title}
                    description={item.Hero.Description}
                    label={item.Hero.Label}
                    url={item.Hero.url}
                    key={index}
                    sectionStyle = "white"
                  ></Hero>
                )
              case "basic-components.branches-component":
                const branchesBgColor = item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'dark'; 
                return(
                  <Branches key={index} branchList={item.BranchesList} title={item.Title} sectionStyle={branchesBgColor} />
                )
              case "basic-components.video-section":
                return(
                  <VideoComponent key={index} src={item.YoutubeURL}/>
                )
              case "basic-components.testimonial-section":
                return(
                    <div key={index} className="">
                      <QuoteCarousel quoteList={item.Testimonial}></QuoteCarousel>
                    </div>
                )
              case "cta.cta-section":
                const sectionBgColor = item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'dark'; 
                const fullWidthSectionBgColo =  item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'white'; 
                return(
                  <div key={index}>
                    {item.CTA !== undefined && item.CTA.length > 1 ? (<Tiles data={item.CTA} width='half' key={index} sectionStyle={sectionBgColor}></Tiles>) : ("")}

                    {item.CTA !== undefined && item.CTA.length === 1 ? (<Tiles data={item.CTA} key={index} singleFlag={true} width='full' sectionStyle={fullWidthSectionBgColo}></Tiles>) : ("")
                      // (item.CTA !== null && Object.keys(item.CTA).length === 1)?<Tiles data={item.CTA} singleFlag={true}></Tiles>:""
                      //don't forget to fix this once the cta.length of a json (dynamic zone) is found
                    }
                  </div>
                )
                case "basic-components.image-carousel-section":
                  return(
                    <div key={index}>
                      {item.ImageCarousel ? (
                          <div className="event-page-image uk-height-medium uk-cover-container uk-margin-none">
                            <Img
                              fluid={
                                GetImgUrl(item.ImageCarousel.Images.localFile___NODE)
                                  .fluid
                              }
                              alt="image"
                            ></Img>
                          </div>
                      ) : null}
                    </div>
                  )
                case "basic-components.image-carousel":
                  return (               
                    item.Images 
                      ? ( <div key={index} className="image_wrap">
                        <div className="image-section uk-cover-container uk-margin-none">
                          {/* <img src={item.Images.publicURL} alt="" data-uk-cover/> */}
                          <Img
                            // fluid={item.Images.childImageSharp.fluid}
                            fluid={GetImgUrl(item.Images.localFile___NODE).fluid}
                            alt={"image"}
                            data-uk-cover
                          ></Img>
                        </div>
                      </div>
                      ) 
                      : ("")
                  )
                case "basic-components.steps-component":
                  return(
                    <StepsComponent key={index} stepsList={item.StepsList} sectionStyle="white" />
                  )
                case "basic-components.faq-component":
                  return(
                    <FAQComponent key={index} faqList={item.FAQList} sectionStyle="white" />
                  )             
                case "basic-components.signup-component":
                  return(
                    <Signup
                      title="Sign Up to Our Newsletter"
                      description="Get updates on all the lastest information, or stay informed about our courses"
                      buttonLabel="Sign Up"
                      sectionStyle = "white"
                    />
                  )
                case "basic-components.swirl-component":                
                  return(
                    <SwirlComponent 
                      key={index} 
                      bgColor={item.SwirlColor} topSwirl={item.Position == "Top" ? true : false} 
                      />
                  )
                default:
                  return ('')
          }
        }
        )} 
        </div>
      </Layout>
    </div>
  );
};

export default newsArticle;
